if (!customElements.get('ft-garden-catalog')) {
  customElements.define('ft-garden-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.grid = this.querySelector('[data-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-garden-card]'));
      this.price = this.querySelector('[data-price-filter]');
      this.sort = this.querySelector('[data-sort]');
      this.count = this.querySelector('[data-count]');
      this.more = this.querySelector('[data-more]');
      this.empty = this.querySelector('[data-empty]');
      this.buttons = Array.from(this.querySelectorAll('[data-group]'));
      this.featured = (this.dataset.featured || '').split(',');
      this.shown = 6;
      this.group = 'alle';
      this.cards.forEach(card => {
        const title = card.dataset.title.toLocaleLowerCase('de-DE');
        const groups = [];
        if (title.includes('schiefer')) groups.push('schiefer');
        else {
          if (/rose|kleeblatt|pumpkin/.test(title)) groups.push('blumen');
          if (/igel|hund|katze|vogel|hase|schmetterling/.test(title)) groups.push('tiere');
          if (/willkommen|kleeblatt/.test(title)) groups.push('willkommen');
          if (/dampflok|waggon/.test(title)) groups.push('eisenbahn');
          if (!groups.length) groups.push('figuren');
        }
        card.gardenGroups = groups;
      });
      const url = new URL(window.location.href);
      const group = url.searchParams.get('gd_motif');
      if (this.buttons.some(button => button.dataset.group === group)) this.group = group;
      const price = url.searchParams.get('gd_price');
      if (['0', '2500', '5000'].includes(price)) this.price.value = price;
      const sort = url.searchParams.get('gd_sort');
      if (['auswahl', 'asc', 'desc'].includes(sort)) this.sort.value = sort;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.group = button.dataset.group;
        this.shown = 6;
        this.update(true);
      }));
      this.price.addEventListener('change', () => { this.shown = 6; this.update(true); });
      this.sort.addEventListener('change', () => { this.shown = 6; this.update(true); });
      this.more.addEventListener('click', () => {
        const firstNew = this.visibleMatches[this.shown];
        this.shown = this.visibleMatches.length;
        this.update(false);
        firstNew?.querySelector('a')?.focus({ preventScroll: true });
      });
      this.querySelectorAll('[data-garden-controls]').forEach(element => { element.hidden = false; });
      this.update(false);
    }
    update(writeUrl) {
      const max = Number(this.price.value);
      const ordered = [...this.cards].sort((a, b) => {
        if (this.sort.value === 'asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'desc') return Number(b.dataset.price) - Number(a.dataset.price);
        const aRank = this.featured.indexOf(a.dataset.id);
        const bRank = this.featured.indexOf(b.dataset.id);
        return (aRank < 0 ? 999 : aRank) - (bRank < 0 ? 999 : bRank) || Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder);
      });
      this.visibleMatches = ordered.filter(card => (this.group === 'alle' || card.gardenGroups.includes(this.group)) && (!max || Number(card.dataset.price) <= max));
      const visible = new Set(this.visibleMatches.slice(0, this.shown));
      ordered.forEach(card => {
        card.hidden = !visible.has(card);
        this.grid.append(card);
      });
      const total = this.visibleMatches.length;
      this.count.textContent = total + ' ' + (total === 1 ? this.dataset.itemLabel : this.dataset.itemsLabel);
      this.empty.hidden = total > 0;
      this.more.hidden = this.shown >= total;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.group === this.group)));
      if (writeUrl) {
        const url = new URL(window.location.href);
        [['gd_motif', this.group, 'alle'], ['gd_price', this.price.value, '0'], ['gd_sort', this.sort.value, 'auswahl']].forEach(([key, value, fallback]) => {
          if (value === fallback) url.searchParams.delete(key);
          else url.searchParams.set(key, value);
        });
        window.history.replaceState(window.history.state, '', url);
      }
    }
  });
}
